import { render } from "./GateWaysList.vue?vue&type=template&id=82fc1ad4&scoped=true&ts=true"
import script from "./GateWaysList.vue?vue&type=script&lang=ts"
export * from "./GateWaysList.vue?vue&type=script&lang=ts"

import "./GateWaysList.vue?vue&type=style&index=0&id=82fc1ad4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fc1ad4"]])

export default __exports__